import React, { lazy, Suspense } from 'react';

import ProductListInfo from './ProductListInfo';
import Filter from '../../components/Filter';
import ProductsListGrid from './ProductsListGrid';
import EmptyCollection from '../../components/EmptyCollection';
import hideFiltersCollection from '../../constants/hide-filters-collection';
import Loader from '../../components/Loader';
import ProductTestimonials from '../products-v2/ProductTestimonials';
import FaqContainer from '../../components/FAQ';

import './ProductsListPage.scss';

const CollectionGrid = lazy(() => import('../../components/CollectionGrid'));
const ProductsListPage = ({
	productsList,
	cart,
	collection,
	filter,
	collectionFilters,
	collectionSorts,
	allSellingPlanGroups,
	collectionFAQ,
}) => {
	const hideFilters = hideFiltersCollection.includes(collection.handle);
	const collectionFAQTitle = collectionFAQ?.content?.body?.find(
		(blok) => blok.component === 'faqTitle'
	);
	const collectionFAQSections = collectionFAQ?.content?.body?.filter(
		(blok) => blok.component === 'faqSection'
	);
	const collectionTestimonials = collection?.metafields?.find((item) => item.key === 'testimonials')?.value;
	const parsedTestimonials = JSON.parse(collectionTestimonials || '[]');
	return (
		<div className='plp-page'>
			<div className='container'>
				<ProductListInfo {...collection} />
				{!productsList.length ? (
					<EmptyCollection />
				) : (
					<>
						{!hideFilters && (
							<Filter
								query={filter}
								list={productsList}
								collectionFilters={collectionFilters}
								collectionSorts={collectionSorts}
							/>
						)}
						<ProductsListGrid
							collection={collection}
							productsList={productsList}
							cart={cart}
							filter={filter}
							allSellingPlanGroups={allSellingPlanGroups}
						/>
						{parsedTestimonials &&
							parsedTestimonials.length > 0 && (
								<section className='plp-page__testimonials'>
									<ProductTestimonials reviews={parsedTestimonials} isCollection />
								</section>
							)}
						<Suspense fallback={<Loader />}>
							<CollectionGrid />
						</Suspense>

						{collectionFAQTitle &&
							collectionFAQSections &&
							collectionFAQSections.length > 0 && (
								<Suspense fallback={<Loader />}>
									<FaqContainer
										title={collectionFAQTitle}
										sections={collectionFAQSections}
									/>
								</Suspense>
							)}
					</>
				)}
			</div>
		</div>
	);
};

export default ProductsListPage;
